// extracted by mini-css-extract-plugin
export default {"card":"Card_card__SVzb+","mobile":"Card_mobile__ocyhK","sections":"Card_sections__et3tM"};